// Node Module Imports
import React, { Component } from 'react'

import { FaTimes } from 'react-icons/fa'
import styled from 'styled-components'

// Component Imports
import { colors } from '../../style/design-system'
import Portal from './Portal'

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 102vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalCard = styled.div`
  position: relative;
  background: white;
  border-radius: .3125rem;
  width: 100%;
  height: 100%;
  z-index: 10;
  overflow: auto;
`

const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 2.5rem;
  border: none;
  background: transparent;
  padding: .625rem;
  cursor: pointer;
`

class ModalFullScreen extends Component {
  componentDidMount = () => {
    document.querySelector('body').classList.add('modal-open')
  }

  componentWillUnmount = () => {
    document.querySelector('body').classList.remove('modal-open')
  }

  closeModal = () => {
    this.props.closeModal()
  }

  render() {
    const { className, children } = this.props
    return (
      <Portal>
        <ModalWrapper className={className}>
          <ModalCard>
            {children}
            <CloseButton className="no-outline" onClick={this.closeModal}>
              <FaTimes color={colors.umaDarkGray} name="close" />
            </CloseButton>
          </ModalCard>
        </ModalWrapper>
      </Portal>
    )
  }
}

export default styled(ModalFullScreen)`
  [class^="FormWrapperGray"] {
    min-height: 100vh;
  }
`
